import { useCallback, useState } from 'react'
import { useMediaQuery } from 'react-responsive'
import { Mobile } from '../../../components/media'
import Modal from '../../../components/modal'
import UpdatePasswordRequestSuccess from '../views/update-password-request-success'
import UpdatePasswordRequest from '../views/update-password-request'

const VIEWS = { updatePassword: 0, updatePasswordSuccess: 1 }

export default function UpdatePassword({ onClose }) {
  const isMobile = useMediaQuery({ query: '(max-width: 1024px)' })
  const [view, setView] = useState(VIEWS.updatePassword)

  const handlePasswordUpdateSuccess = useCallback(() => setView(VIEWS.updatePasswordSuccess), [])

  return (
    <Modal onClose={onClose} hideCloseBtn={isMobile}>
      <Mobile>
        <button className='flatBtn backToAccount' onClick={onClose}>
          &#60; Back to Account
        </button>
      </Mobile>

      {view === VIEWS.updatePassword && (
        <UpdatePasswordRequest onSuccess={handlePasswordUpdateSuccess} />
      )}
      {view === VIEWS.updatePasswordSuccess && <UpdatePasswordRequestSuccess onClose={onClose} />}

      <style jsx>{`
        .backToAccount {
          margin: 1rem 0 0 1.3rem;
          color: #a5a8b9;
          line-height: 1.6rem;
          font-size: 1.2rem;
          font-weight: bold;
        }
      `}</style>
    </Modal>
  )
}
